import React from 'react';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';

const MyResponsivePie = ({ data }) => {
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      startAngle={360}
      endAngle={0}
      sortByValue={true}
      innerRadius={0.6}
      padAngle={1}
      cornerRadius={5}
      colors={data => data.color}
      borderWidth={1}
      borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.5 ] ] }}
      radialLabelsSkipAngle={10}
      radialLabelsTextXOffset={6}
      radialLabelsTextColor="#333333"
      radialLabelsLinkOffset={0}
      radialLabelsLinkDiagonalLength={16}
      radialLabelsLinkHorizontalLength={24}
      radialLabelsLinkStrokeWidth={1}
      radialLabelsLinkColor={{ from: 'color' }}
      slicesLabelsSkipAngle={10}
      slicesLabelsTextColor="#333333"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      defs={[
        {
          id: 'gradient',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: 'inherit' },
            { offset: 100, color: 'inherit', opacity: 0.3 },
          ],
        },
        {
          id: 'lines',
          type: 'patternLines',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.2)',
          rotation: -45,
          lineWidth: 6,
          spacing: 10
        }
      ]}
      fill={[
        {
          match: {
            id: 'All'
          },
          id: 'lines'
        },
        {
          match: {
            id: 'Black & White'
          },
          id: 'gradient'
        },
        {
          match: {
            id: 'Travel'
          },
          id: 'gradient'
        },
        {
          match: {
            id: 'Portrait'
          },
          id: 'gradient'
        },
        {
          match: {
            id: 'Paris'
          },
          id: 'gradient'
        }
      ]}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          translateY: 56,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: '#999',
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000'
              }
            }
          ]
        }
      ]}
    />
  )
}

export default MyResponsivePie;
